import React from "react";
import styled from "styled-components";
import GithubIcon from "../../GithubIcon";
import LinkedInIcon from "../../LinkedInIcon";
import { colors, radius } from "../theme";
import { AppScroll, AppEyebrow, AppTitle, AppLead } from "./shared";

interface Link {
  label: string;
  handle: string;
  href: string;
  accent: string;
  icon: React.ReactNode;
}

const links: Link[] = [
  {
    label: "GitHub",
    handle: "@harriq",
    href: "https://github.com/harriq",
    accent: colors.green,
    icon: <GithubIcon color={colors.ink} />,
  },
  {
    label: "LinkedIn",
    handle: "in/harrisonqu",
    href: "https://www.linkedin.com/in/harrisonqu/",
    accent: colors.sky,
    icon: <LinkedInIcon color={colors.ink} />,
  },
];

const Row = styled.a<{ $accent: string }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  margin-bottom: 14px;
  border: 2px solid ${colors.ink};
  border-radius: ${radius.md};
  background: #fff;
  text-decoration: none;
  color: ${colors.ink};
  box-shadow: 4px 4px 0 rgba(29, 29, 31, 0.12);
  transition: transform 0.14s ease, background 0.14s ease;

  &:hover {
    transform: translate(-2px, -2px);
    background: ${({ $accent }) => $accent};
  }
`;

const IconBubble = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: ${radius.pill};
  border: 2px solid ${colors.ink};
  background: #fff;
`;

const Label = styled.div`
  font-size: 17px;
  font-weight: 700;
`;

const Handle = styled.div`
  font-size: 14px;
  color: ${colors.inkSoft};
`;

const ContactApp = () => (
  <AppScroll>
    <AppEyebrow>Let's make something together</AppEyebrow>
    <AppTitle>Get in touch</AppTitle>
    <AppLead>
      Always happy to chat, hit me up and let's
      see what we can build :)
    </AppLead>
    <div style={{ marginTop: 14 }}>
      {links.map((link) => (
        <Row
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noreferrer"
          $accent={link.accent}
        >
          <IconBubble>{link.icon}</IconBubble>
          <div>
            <Label>{link.label}</Label>
            <Handle>{link.handle}</Handle>
          </div>
        </Row>
      ))}
    </div>
  </AppScroll>
);

export default ContactApp;
